import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'AO' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'AO', label: 'Awesome Oscillator', pane: 'sub', params: [5, 34], outputs: ['ao'], histogram: 'ao' })
